import React from "react";
import BrandManagerShell from "./components/BrandManagerShell";
import UserManagementPage from "./pages/UserManagementPage";

/**
 * Client User Management hosted in Brand Manager (portfolio / global plane).
 * Same UserManagementPage component as Brand-shell UM — one SOR, two scopes.
 */
export default function BrandManagerUserManagement({ activeTab }) {
  return (
    <BrandManagerShell>
      <UserManagementPage activeTab={activeTab} />
    </BrandManagerShell>
  );
}
